import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78d2bd36"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  density: "compact",
  class: "area-btns"
}

import { withDefaults, ref, watch, onMounted } from 'vue';
import { IToggleButon } from '@/types';
interface IProps {
  buttons: Array<IToggleButon>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomToogleButton',
  props: {
    buttons: null
  },
  emits: ['handleToggle'],
  setup(__props: any, { emit }) {

const props = __props as { buttons: Array<IToggleButon> };

const toggleBtn = ref('');



watch(
  () => toggleBtn.value,
  () => {
    emit('handleToggle', toggleBtn.value);
  }
);

onMounted(() => {
  toggleBtn.value = props.buttons[0].value;
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.buttons, (col, index) => {
      return (_openBlock(), _createBlock(_component_v_btn, {
        elevation: "0",
        onClick: ($event: any) => (toggleBtn.value = col.value),
        key: String(index),
        class: _normalizeClass(["btn-text", { active: toggleBtn.value === col.value }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(col.text), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "class"]))
    }), 128))
  ]))
}
}

})